const addressList = document.querySelector('.address-list');
const radioInput = addressList.querySelectorAll('.address-card-input');
const selectedItemContainer = addressList.querySelector('.selected-label');
const closeButtonBack = document.getElementsByName("closeAddressModalButtonBack");
const closeButtonNext = document.getElementsByName('closeAddressModalButtonNext');
const validSelectedMessage = document.querySelector('.selected-message.valid');
const notValidElements = document.querySelectorAll(".not-valid");
const validElements = document.querySelectorAll(".valid");
let inputAddress = {};
let verifiedAddress = {};
let selectedAddress = 'verified';

// Close modal and do not proceed
closeButtonBack[0].addEventListener('click', function () {
  closeAddressModal();
});

// Close modal and submit trade in
closeButtonNext[0].addEventListener('click', async function () {
  selectedAddress = document.querySelector(
    'input[name = addresses]:checked'
  ).value;
  const addressToUse = selectedAddress === 'verified' ? verifiedAddress : inputAddress;
  const tradeinUuid = localStorage.getItem('tradeinUuid');

  closeAddressModal();

  let pathname;
  if (global.useTradeInDiti2) {
    localStorage.setItem('addressInfo', JSON.stringify(addressToUse));
    if (global.useSendbackOptIn) {
      pathname = `${window.location.pathname.match(/.*pages/i)[0]}/trade-in-shipping-return`;
    } else {
      pathname = `${window.location.pathname.match(/.*pages/i)[0]}/trade-in-shipping-review`;
    }
  } else {
    await submitTradeIn(addressToUse);
    pathname = `${window.location.pathname.match(/.*pages/i)[0]}/trade-in-confirmation`;
    localStorage.removeItem('tradeinUuid');
  }
  window.location.href = appendReferrerToUrl(`${pathname}?tradeinuuid=${tradeinUuid}`);
});

function setValidSelectedMessageContent() {
  const {
    unverifiedAddressSelectedMessageHtml,
    verifiedAddressSelectedMessageHtml,
  } = ADDRESS_VALIDATION_CONFIG;
  const isVerifiedAddressSelected = document.querySelector(
    'input[name=addresses]:checked'
  )?.value === 'verified';
  validSelectedMessage.innerHTML = isVerifiedAddressSelected ?
    verifiedAddressSelectedMessageHtml :
    unverifiedAddressSelectedMessageHtml;
}

function onAddressSelectionChanged() {
  setValidSelectedMessageContent();
}

radioInput.forEach((radio) => {
  radio.addEventListener('change', onAddressSelectionChanged);
});

function closeAddressModal() {
  document.querySelector('.address-modal').classList.remove('address-modal-open');
}

function openAddressModal(isValid) {
  const unverifiedFields = document.getElementsByName('unverified-field');
  const verifiedFields = document.getElementsByName('verified-field');
  ["address1", "address2", "city", "country", "state", "postalCode"].forEach((key, idx) => {
    unverifiedFields[idx].textContent = inputAddress[key];
    verifiedFields[idx].textContent = verifiedAddress[key];
  });

  radioInput.forEach((el) => {
    if (!isValid && el.value == "unverified") {
      el.checked = true;
    } else if (isValid && el.value == "verified") {
      el.checked = true;
    }
  });
  setValidSelectedMessageContent();

  if (isValid) {
    validElements.forEach((el) => {
      el.classList.remove("hidden");
    });
    notValidElements.forEach((el) => {
      el.classList.add("hidden");
    });
  } else {
    validElements.forEach((el) => {
      el.classList.add("hidden");
    });
    notValidElements.forEach((el) => {
      el.classList.remove("hidden");
    });
  }
  document.querySelector('.address-modal').classList.add('address-modal-open');
}

function validateAddressRequest(addressData) {
  const { address1, address2, city, country, state, postalCode } = addressData;
  return fetchWithAppName(
    `${global.url}query-validateAddress`,
    {
      body: JSON.stringify({
        query: `
          query validateAddress(
            $address: AddressInputCommerce
          ) {
            validateAddress(
              address: $address
              # Do NOT pass partnerUuid here. The code path that the trade-in plugin uses (using
              # market-api) doesn't do it, so we won't do it here either.
            ) {
              recommendedAddress {
                address1
                address2
                city
                country
                state
                postalCode
              }
              analysis {
                validationResult
              }
            }
          }`,
        variables: {
          address: {
            address1,
            address2,
            city,
            country,
            state,
            postalCode,
          },
        },
      }),
    }
  )
    .then((response) => response.json())
    .then((data) => {
      return data.data.validateAddress;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

function renderAddressError() {
  document.querySelector('.address-error').classList.remove('hidden');
}

function validateAddress(addressData) {
  document.querySelector('.address-error').classList.add('hidden');

  validateAddressRequest(addressData)
    .then(({ recommendedAddress, analysis }) => {
      inputAddress = structuredClone(addressData);
      verifiedAddress = {
        // Pass along customer fields from provided addressData in addition to new address fields
        // from recommendedAddress so that customer fields get echoed back correctly if returning to
        // the shipping page.
        ...structuredClone(addressData),
        ...recommendedAddress,
      };
      // partially_valid is quite common. Consider it valid too.
      const isValid = ['valid', 'partially_valid'].includes(analysis.validationResult);
      openAddressModal(isValid);
    })
    .catch(() => {
      renderAddressError();
    });
}
